module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "size": "small"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Minute papillon...")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('spinner')], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_vm._v("\n              demande en cours de traitement\n          ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-108695c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/spinning-modal.vue
// module id = 708
// module chunks = 0